// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { SettingsOutlined, ShareOutlined } from '@mui/icons-material';
// type
import { NavItemType } from '../types/menu';
import { useSettingsMenuItems } from './settings';
import { DeepReadonly } from '../types/DeepReadonly';
import { useMemo } from 'react';
import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useConnectionMenuItems } from './connection';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const useConfigurationMenuItems = (): DeepReadonly<NavItemType> => {
	const connectionMenuItems = useConnectionMenuItems();
	const settingsMenuItems = useSettingsMenuItems();
	const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	return useMemo(
		() => ({
			id: 'configuration',
			type: 'group',
			children: [
				{
					id: 'connection',
					title: <FormattedMessage id={'menu.connection'} />,
					type: 'item',
					url: '/connections/data-sources',
					icon: ShareOutlined,
					children: connectionMenuItems,
					isActive: (location) => location.pathname.startsWith('/connections'),
				},
				{
					id: 'settings',
					title: <FormattedMessage id={'menu.settings'} />,
					type: matchDownSM ? 'collapse' : 'item',
					url: '/settings/my-account',
					icon: SettingsOutlined,
					children: settingsMenuItems,
					isActive: (location) => location.pathname.startsWith('/settings'),
				},
			],
		}),
		[connectionMenuItems, settingsMenuItems, matchDownSM],
	);
};

export { useConfigurationMenuItems };
